import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Endeavor Types API service
 */
export const EndeavorTypeApi = {
  /**
   * Get all endeavor types
   * @returns {Promise<Response>} All endeavor types response
   */
  getEndeavorTypes: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types`, {
      method: 'GET',
    });
  },

  /**
   * Get endeavor type by ID
   * @param {string|number} id - Endeavor type ID
   * @returns {Promise<Response>} Endeavor type response
   */
  getEndeavorType: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${id}`, {
      method: 'GET',
    });
  },

  /**
   * Get endeavor type by name (Admin only)
   * @param {string} name - Endeavor type name
   * @returns {Promise<Response>} Endeavor type response
   */
  getEndeavorTypeByName: async (name) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/name/${encodeURIComponent(name)}`, {
      method: 'GET',
    });
  },

  /**
   * Create endeavor type (Admin only)
   * @param {Object} data - Endeavor type data
   * @returns {Promise<Response>} Create response
   */
  createEndeavorType: async (data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Update endeavor type (Admin only)
   * @param {string|number} id - Endeavor type ID
   * @param {Object} data - Updated endeavor type data
   * @returns {Promise<Response>} Update response
   */
  updateEndeavorType: async (id, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Delete endeavor type (Admin only)
   * @param {string|number} id - Endeavor type ID
   * @returns {Promise<Response>} Delete response
   */
  deleteEndeavorType: async (id) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${id}`, {
      method: 'DELETE',
    });
  },

  /**
   * Get metadata definitions for endeavor type
   * @param {string|number} endeavorTypeId - Endeavor type ID
   * @returns {Promise<Response>} Metadata definitions response
   */
  getEndeavorTypeMetadataDefinitions: async (endeavorTypeId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${endeavorTypeId}/metadata-definitions`, {
      method: 'GET',
    });
  },

  /**
   * Get required metadata definitions for endeavor type
   * @param {string|number} endeavorTypeId - Endeavor type ID
   * @returns {Promise<Response>} Required metadata definitions response
   */
  getRequiredEndeavorTypeMetadataDefinitions: async (endeavorTypeId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${endeavorTypeId}/required-metadata-definitions`, {
      method: 'GET',
    });
  },

  /**
   * Add metadata definition to endeavor type (Admin only)
   * @param {string|number} endeavorTypeId - Endeavor type ID
   * @param {Object} data - Metadata definition data
   * @returns {Promise<Response>} Add metadata definition response
   */
  addMetadataDefinitionToEndeavorType: async (endeavorTypeId, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${endeavorTypeId}/metadata-definitions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Update endeavor type metadata definition (Admin only)
   * @param {string|number} endeavorTypeId - Endeavor type ID
   * @param {string|number} metadataDefId - Metadata definition ID
   * @param {Object} data - Updated metadata definition data
   * @returns {Promise<Response>} Update response
   */
  updateEndeavorTypeMetadataDefinition: async (endeavorTypeId, metadataDefId, data) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${endeavorTypeId}/metadata-definitions/${metadataDefId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  /**
   * Delete endeavor type metadata definition (Admin only)
   * @param {string|number} endeavorTypeId - Endeavor type ID
   * @param {string|number} metadataDefId - Metadata definition ID
   * @returns {Promise<Response>} Delete response
   */
  deleteEndeavorTypeMetadataDefinition: async (endeavorTypeId, metadataDefId) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/endeavor-types/${endeavorTypeId}/metadata-definitions/${metadataDefId}`, {
      method: 'DELETE',
    });
  }
};